/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow_down.svg'

export default function TableHeaders({ t, sorter, setSorter, category }) {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()
  const renderType = searchParams?.get('type') || 'name'
  const renderAsc = searchParams?.get('asc') || true

  t = t || ((text) => text)

  useEffect(() => {
    setSorter({
      type: renderType,
      asc: renderAsc === 'false' ? false : true
    })
  }, [location])

  const changeSort = (e) => {
    const newSort = e.target.getAttribute('name')
    const { asc } = sorter
    if (sorter?.type !== newSort) {
      searchParams.set('type', newSort)
      searchParams.set('asc', 'true')
    } else {
      searchParams.set('asc', !asc)
    }
    const newUrl = '/management/' + category + '?' + searchParams.toString().replace(/%2C/g, ',')
    navigate(newUrl)
  }

  return (
    <tr className={styles.table_tr}>
      <th
        className={`${styles.table_th} ${sorter?.type === 'full_name' ? styles.active : ''}`}
        onClick={changeSort}
        name='full_name'
        style={{ textAlign: 'start' }}
        scope='col'
      >
        {t('full_name')}
        <ArrowDown className={`${styles.sorter_arrow} ${!sorter.asc && sorter?.type === 'full_name' ? styles.desc : ''} `} />
      </th>

      <th
        className={`${styles.table_th} ${sorter?.type === 'operation' ? styles.active : ''}`}
        onClick={changeSort}
        name='operation'
        scope='col'
      >
        {t('operation')}
        <ArrowDown className={`${styles.sorter_arrow} ${!sorter.asc && sorter?.type === 'operation' ? styles.desc : ''} `} />
      </th>
      <th
        className={`${styles.table_th} ${sorter?.type === 'appointments' ? styles.active : ''}`}
        onClick={changeSort}
        name='appointments'
        scope='col'
      >
        {t('appointments')}
        <ArrowDown className={`${styles.sorter_arrow} ${!sorter.asc && sorter?.type === 'appointments' ? styles.desc : ''} `} />
      </th>
      <th className={`${styles.table_th} ${sorter?.type === 'file' ? styles.active : ''}`} onClick={changeSort} name='file' scope='col'>
        {t('file')}
        <ArrowDown className={`${styles.sorter_arrow} ${!sorter.asc && sorter?.type === 'file' ? styles.desc : ''} `} />
      </th>
    </tr>
  )
}
